import { render, staticRenderFns } from "./stationDiscountBase.vue?vue&type=template&id=1713ed36&"
import script from "./stationDiscountBase.vue?vue&type=script&lang=js&"
export * from "./stationDiscountBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1713ed36')) {
      api.createRecord('1713ed36', component.options)
    } else {
      api.reload('1713ed36', component.options)
    }
    module.hot.accept("./stationDiscountBase.vue?vue&type=template&id=1713ed36&", function () {
      api.rerender('1713ed36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/stationManage/stationDiscount/stationDiscountBase.vue"
export default component.exports